import { IconButton, Stack } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import dayjs, { Dayjs } from "dayjs";
import { SafeDatePicker } from "components/SafeDatePicker";
import { useTenantTranslation } from "hooks/formatters";
import { useLocalDatetime } from "hooks/useLocalDateTime";
import { getCurrentCalendarMonth } from "src/utils/toLocalCalendarTime";

type MonthStepperProps = Readonly<{
  selectedMonth: Dayjs;
  setSelectedMonth: (month: Dayjs) => void;
}>;

export const MonthStepper = ({
  selectedMonth,
  setSelectedMonth,
}: MonthStepperProps) => {
  const { t } = useTenantTranslation();
  const { localTimezone } = useLocalDatetime();
  const currentMonth = getCurrentCalendarMonth(localTimezone);

  const isCurrentMonth = selectedMonth.isSame(currentMonth, "month");

  return (
    <Stack direction="row" spacing={0} alignItems="center">
      <IconButton
        aria-label={t("previous")}
        size="small"
        onClick={() => {
          setSelectedMonth(selectedMonth.subtract(1, "month"));
        }}
      >
        <ChevronLeftIcon />
      </IconButton>
      <SafeDatePicker
        label={t("month")}
        views={["month", "year"]}
        value={selectedMonth}
        onChange={(newValue) => {
          if (newValue) {
            setSelectedMonth(dayjs.utc(newValue.format("YYYY-MM-01")));
          }
        }}
        maxDate={currentMonth}
        slotProps={{
          textField: { size: "small" },
        }}
      />
      <IconButton
        aria-label={t("next")}
        size="small"
        onClick={() => {
          setSelectedMonth(selectedMonth.add(1, "month"));
        }}
        disabled={isCurrentMonth}
      >
        <ChevronRightIcon />
      </IconButton>
    </Stack>
  );
};
